import { useQuery } from "@tanstack/react-query";
import { fetchUserPermissions } from "../services/usersServices"

export const useUserPermissions = (email) => {
  return useQuery({
    queryKey: ["userPermissions", email],
    queryFn: fetchUserPermissions,
    enabled: !!email
  });
};
